import script from "./PromotionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionItem.vue?vue&type=script&setup=true&lang=js"

import "./PromotionItem.vue?vue&type=style&index=0&id=58608099&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58608099"]])

export default __exports__